// extracted by mini-css-extract-plugin
export default {"navContainer":"nav_navContainer__r2JPA","nav":"nav_nav__q6x9C","list":"nav_list__FdFHe"};